import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import $ from "jquery";
import React, { useEffect, useRef } from "react";
import { createRoot } from "react-dom/client";
import { useContextEmpleado } from "../../../../contexto/empleado/EmpleadoContext";
import { useContextUsuario } from "../../../../contexto/usuario/UsuarioContext";
import ModalPromocion from "./ModalPromocion";
import EliminarPromocion from "./EliminarPromocion";
import { useNavigate } from "react-router-dom";

const TablaEditarPromociones = ({ datos }) => {
    const { token } = useContextUsuario();
    const { setListaPromociones, ActualizarLista } = useContextEmpleado();
    const tableRef = useRef();
    const navigate = useNavigate();

    const handleEditarPromociones = (rowData) => {
        //console.log('Row', rowData);
        navigate(`/app/admin/promociones/editar/${rowData.id}`, {
            state: { datos: rowData }
        });
    };
    
    // Mapeo badges para tipo y estado
    const tipoBadgeClasses = {
        Total: "badge-primary",
        Unico: "badge-success",
        Combo: "badge-warning",
        Evento: "badge-info",
    };

    const estadoBadgeClasses = {
        Activo: "badge-success",
        Inactivo: "badge-secondary",
        Agotado: "badge-danger",
    };

    // Formatear fecha a dd/mm/yyyy
    const formatearFecha = (fechaIso) => {
        if (!fechaIso) return "";
        const d = new Date(fechaIso);
        return d.toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" });
    };

    // Capitalizar y mostrar días de la semana
    const formatearDiasSemana = (diasStr) => {
        if (!diasStr) return "";
        return diasStr
            .split(",")
            .map(dia => dia.charAt(0).toUpperCase() + dia.slice(1).toLowerCase())
            .join(", ");
    };

    useEffect(() => {
        if (datos.length > 0) {
            const requiredFields = [
                "id",
                "nombre",
                "descripcion",
                "tipo",
                "fechaInicio",
                "fechaFin",
                "hora_inicio",
                "hora_fin",
                "diasSemana",
                "estado",
                "descuento",
                "descuentoTotal",
                "limite_total",
                "limite_cliente",
            ];
            const missingFields = requiredFields.filter(field => !datos[0].hasOwnProperty(field));
            if (missingFields.length > 0) {
                console.error(`Los datos no contienen las propiedades necesarias: ${missingFields.join(", ")}`);
                return;
            }
        }

        $(tableRef.current).DataTable({
            data: datos,
            columns: [
                {
                    targets: 0,
                    title: "Opciones",
                    data: null,
                    className: "dt-center",
                    searchable: false,
                    createdCell: (td, cellData, rowData, row, col) => {
                        const root = createRoot(td);
                        root.render(
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "1em",
                                }}
                            >
                                <ModalPromocion
                                    key={`modal-${rowData.id}`}
                                    datos={rowData}
                                    token={token}
                                    setListaPromociones={setListaPromociones}
                                    ActualizarLista={ActualizarLista}
                                />
                                <button
                                    key={`edit-${rowData.id}`}
                                    className="btn btn-warning"
                                    title="Editar Promoción"
                                    style={{ minWidth: "35px" }}
                                    onClick={() => handleEditarPromociones(rowData)}
                                >
                                    <i className="fas fa-pen" />
                                </button>
                                <EliminarPromocion
                                    key={`delete-${rowData.id}`}
                                    datos={rowData}
                                    token={token}
                                    setListaPromociones={setListaPromociones}
                                    ActualizarLista={ActualizarLista}
                                />
                            </div>
                        );
                    },
                    orderable: false,
                },
                { targets: 1, title: "Id", data: "id" },
                {
                    targets: 2,
                    title: "Nombre y Descripción",
                    data: null,
                    render: (data, type, row) => (
                        `${row.nombre}<br/><small>${row.descripcion}</small>`
                    ),
                },
                {
                    targets: 3,
                    title: "Tipo",
                    data: "tipo",
                    render: (data) => {
                        const clase = tipoBadgeClasses[data] || "badge-light";
                        return `<span class="badge ${clase}">${data}</span>`;
                    },
                },
                {
                    targets: 4,
                    title: "Fecha Inicio",
                    data: "fechaInicio",
                    render: (data) => formatearFecha(data),
                },
                {
                    targets: 5,
                    title: "Fecha Fin",
                    data: "fechaFin",
                    render: (data) => formatearFecha(data),
                },
                {
                    targets: 6,
                    title: "Hora Inicio",
                    data: "hora_inicio",
                },
                {
                    targets: 7,
                    title: "Hora Fin",
                    data: "hora_fin",
                },
                {
                    targets: 8,
                    title: "Días Semana",
                    data: "diasSemana",
                    render: (data) => formatearDiasSemana(data),
                },
                {
                    targets: 9,
                    title: "Estado",
                    data: "estado",
                    render: (data) => {
                        const clase = estadoBadgeClasses[data] || "badge-light";
                        return `<span class="badge ${clase}">${data}</span>`;
                    },
                },
                {
                    targets: 10,
                    title: "Descuento",
                    data: "descuento",
                    render: (data) => `<span class="badge badge-warning">${data}</span>`,
                },
                {
                    targets: 11,
                    title: "Descuento Total (L)",
                    data: "descuentoTotal",
                },
                {
                    targets: 12,
                    title: "Límite Total",
                    data: "limite_total",
                },
                {
                    targets: 13,
                    title: "Límite por Cliente",
                    data: "limite_cliente",
                },
            ],
            paging: true,
            lengthChange: true,
            ordering: true,
            info: true,
            autoWidth: false,
            responsive: true,
            destroy: true,
            language: {
                decimal: "",
                emptyTable: "No hay promociones disponibles",
                info: "Mostrando _START_ a _END_ de _TOTAL_ promociones",
                infoEmpty: "Mostrando 0 a 0 de 0 promociones",
                infoFiltered: "(Filtrado de _MAX_ promociones totales)",
                thousands: ",",
                lengthMenu: "Mostrar _MENU_ promociones",
                loadingRecords: "Cargando...",
                processing: "Procesando...",
                search: "Buscar:",
                zeroRecords: "No se encontraron promociones",
                paginate: {
                    first: "|<<",
                    last: ">>|",
                    next: ">>",
                    previous: "<<",
                },
            },
        });
    }, [datos, token, setListaPromociones, ActualizarLista]);

    return (
        <table
            ref={tableRef}
            id="promociones"
            className="table table-bordered table-hover"
            style={{ width: "100%" }}
        ></table>
    );
};

export default TablaEditarPromociones;